<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/agro_exporter/quality_control/container/list_export_quality_inspects.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_control_container_list_templates_path"
    :params="{
      agro_exporter_process_id: agro_exporter_process_id,
      container_id: container_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[
      module_name,
      agro_exporter_process?.name,
      container?.container_code,
      quality_template?.name
    ]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <container-info :container="container"></container-info>

    <div class="mt-6">
      <h1 class="page-title">
        <i class="fa-solid fa-list-ul"></i><span class="space-icon"></span>
        {{ $t("labels.quality_inspects_title") }}
      </h1>

      <div class="mt-8 flex flex-row justify-between">
        <div class="panel-plain-label">
          <badge-default
            :label="
              quality_inspects.length + ' ' + $t('labels.total_number_inspections')
            "
          />
        </div>
        <div>
          <button
            type="button"
            @click.prevent="downloadRepXlsx()"
            class="btn-white"
          >
            <i :class="['fa-solid', downloading ? 'fa-sync fa-spin'  : 'fa-file-excel']"></i
            ><span class="space-icon"></span
            >{{ $t("labels.general_report_button") }}
          </button>
          <span class="space-actions" />

          <new-button
            @click.prevent="goToNewInspection()"
            :label="$t('labels.new_button')"
          />
        </div>
      </div>

      <inspection-details
        v-if="quality_template"
        :quality_template="quality_template"
        :quality_inspects="quality_inspects"
        :goToShow="goToShowQualityInspect"
      ></inspection-details>
      <loading-message v-else />
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import ContainerQualityRequester from "@/views/agro_exporter/requesters/quality_control/container/list_export_quality_inspects.js";
import GoBackLink from "@/components/views/layout/GoBackLink.vue";
import ContainerInfo from "@/components/views/agro_exporter/quality_control/container/ContainerInfo.vue";
import InspectionDetails from "@/components/views/agro_exporter/quality_control/container/InspectionDetails.vue";

export default {
  name: "AEProductionContainerQualityListExportQualityInspects",
  components: {
    GoBackLink,
    ContainerInfo,
    InspectionDetails
  },
  data() {
    return {
      load_data_general: false,
      downloading: false,
      agro_exporter_process: {},
      container: {},
      quality_inspects: [],
      quality_template: {}
    };
  },
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: {
      required: true
    },
    container_id: {
      required: true
    },
    exporter_process_quality_template_id: {
      required: true
    },
    current_tab: {}
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainer();
      await this.fetchExporterQualityTemplate();
      await this.fetchQualityInspects();
      this.load_data_general = true;
    },
    inspectsByTemplate: function (current_tab_id) {
      return this.quality_inspects.filter(
        eq_inspect => eq_inspect.quality_template_id === current_tab_id
      );
    },
    maxSamplings: function (arr) {
      return Math.max(...arr.map(eq_inspect => eq_inspect.samplings));
    },
    fetchAgroExporterProcess: async function () {
      let response = await ContainerQualityRequester.fetchAgroExporterProcess(
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    downloadRepXlsx: async function () {
      this.downloading = true;
      try {
        let response =
          await ContainerQualityRequester.downloadQualityInspectsRepXlsx({
            container_id: this.container_id,
            quality_template_id: this.quality_template.id
          });

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        let name = this.quality_template?.name;
        if (name) name = `${name.split(" ").join("_")}.xlsx`;
        fileLink.setAttribute("download", name ?? "reporte.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading = false;
    },
    fetchContainer: async function () {
      let response = await ContainerQualityRequester.fetchContainer(
        this.agro_exporter_process_id,
        this.container_id
      );
      this.container = response.data;
    },
    fetchQualityInspects: async function () {
      let response = await ContainerQualityRequester.fetchExportQualityInspects(
        this.container_id,
        this.exporter_process_quality_template_id
      );
      this.quality_inspects = response.data;
    },
    fetchExporterQualityTemplate: async function () {
      let response =
        await ContainerQualityRequester.fetchExporterQualityTemplate(
          this.container_id,
          this.exporter_process_quality_template_id
        );
      this.quality_template = response.data;
    },
    switchTab: function (index) {
      if (this.current_tab) return Number(this.current_tab) === index;
      return index == 0;
    },
    goToShowQualityInspect: function (quality_inspect) {
      this.$router.push({
        name: "ae_quality_control_container_show_quality_inspect_path",
        params: {
          container_id: this.container_id,
          quality_inspect_id: quality_inspect.id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id
        }
      });
    },
    goToNewInspection: function () {
      this.$router.push({
        name: "ae_quality_control_container_new_inspection_path",
        params: {
          container_id: this.container_id,
          quality_template_id: this.quality_template?.id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id
        }
      });
    }
  }
};
</script>
